import { Base } from "./base";

export class Scheduler extends Base {
    SchedulerID: number;
    SchedulerTypeID: number;
    ParkingID: number;
    AuhtorID: string;
    HourFrom: number;
    HourTo: number;
    IsAllDay: boolean;
    DayOfWeek: number;

    //Model properties
    HasSensors: boolean;
    
    //Web properties
    Day?: string;

    //Constructors
    constructor(
        schedulerTypeId?: number, 
        hourFrom?: number,
        hourTo?: number,
        isAllDay?: boolean,
        dayOfWeek?: number
    ) {
        super();
        this.SchedulerTypeID = schedulerTypeId;
        this.HourFrom = hourFrom;
        this.HourTo = hourTo;
        this.IsAllDay = isAllDay;
        this.DayOfWeek = dayOfWeek;
    }
}